import { NavLink } from "react-router-dom"
import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button.variants"

interface NavProps {
  onClick?: () => void;
  links: {
    title: string;
    label?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon?: React.ComponentType<any>;
    to: string;
    target?: string;
    testid?: string;
  }[];
}

export function Nav({ links, onClick }: NavProps) {
  return (
    <nav className="grid gap-2">
      {links.map((link, index) => (
        <NavLink
          key={index}
          target={link.target}
          to={link.to}
          className={({ isActive }) =>
            cn(
              buttonVariants({
                variant: isActive ? "soft" : "ghost",
                size: "lg",
              }),
              isActive &&
                "dark:bg-muted dark:text-white dark:hover:bg-muted dark:hover:text-white",
              "justify-start",
            )
          }
          onClick={onClick}
          data-testid={link.testid}
        >
          <div className="px-2">{link.icon && <link.icon />}</div>
          {link.title}
          {link.label && (
            <span className={cn("ml-auto", "py-5")}>{link.label}</span>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
